var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4411 20.715C26.4411 26.7894 21.0349 31.6399 15.9664 31.6399C10.8979 31.6399 5.49216 27.686 5.49219 21.6161C5.49221 16.6605 8.75852 11.9301 11.349 9.56491C13.9394 7.19974 13.9394 1.23047 13.9394 1.23047C13.9394 1.23047 18.0365 4.40475 19.6833 7.19974C21.3035 9.9497 21.0349 12.7185 21.0349 15.4216C23.0621 13.6195 23.0621 11.8175 23.0621 11.8175C24.8643 14.4079 26.4411 15.7594 26.4411 20.715Z",
    fill: "#8E8CEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42179 23.736C8.42179 28.1309 12.3332 31.6403 16.0004 31.6403C19.6675 31.6403 23.5786 28.7796 23.5786 24.3879C23.5786 20.8025 21.2154 17.38 19.3412 15.6687C17.4669 13.9575 17.4669 9.63867 17.4669 9.63867C17.4669 9.63867 14.5026 11.9353 13.3112 13.9575C12.1389 15.9471 12.3332 17.9504 12.3332 19.9061C10.8665 18.6023 10.8665 17.2985 10.8665 17.2985C9.56265 19.1727 8.42179 20.1506 8.42179 23.736Z",
    fill: "#B1B0F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9228 26.4707C20.9228 29.3447 18.365 31.6396 15.9669 31.6396C13.5689 31.6396 11.0112 29.7688 11.0112 26.897C11.0112 24.5523 12.5566 22.3143 13.7822 21.1952C15.0079 20.0762 15.0079 17.252 15.0079 17.252C15.0079 17.252 16.9463 18.7538 17.7255 20.0762C18.4921 21.3773 18.365 22.6873 18.365 23.9662C19.3241 23.1136 19.3241 22.261 19.3241 22.261C20.1768 23.4866 20.9228 24.126 20.9228 26.4707Z",
    fill: "#E6E5FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.dbc95ede23859e90243758a9a706fa02.svg";
export { ForwardRef as ReactComponent };